// extracted by mini-css-extract-plugin
module.exports = {"link":"_24YGi","image":"qNRIf","root":"_1-NAo","ScotchA":"_3QE2P","scotchA":"_3QE2P","ScotchB":"_2YcLC","scotchB":"_2YcLC"};